import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus, HelpCircle } from 'lucide-react';
import { PurchaseCTA } from './PurchaseCTA';
const faqs = [{
  question: '¿Para quién es exactamente este sistema?',
  answer: 'Este sistema está diseñado tanto para facilitadores de constelaciones que buscan profesionalizar su práctica, como para terapeutas holísticos que desean integrar la mirada sistémica en sus consultas. También es ideal para personas en procesos de búsqueda personal que quieran comprender sus lealtades invisibles y encontrar su lugar en el sistema.'
}, {
  question: '¿Necesito tener conocimientos previos en Constelaciones Familiares?',
  answer: 'No es requisito ser un experto. El Sistema Profesional está estructurado para guiarte paso a paso, desde los conceptos fundamentales de los órdenes del amor hasta la aplicación de movimientos de solución complejos. Te brindamos la infraestructura operativa que normalmente no se profundiza en las formaciones teóricas.'
}, {
  question: '¿Cómo recibo el material y por cuánto tiempo tengo acceso?',
  answer: 'El acceso es inmediato. Una vez realizado el pago, recibirás un correo electrónico con tus credenciales de acceso. El acceso es vitalicio, incluyendo todas las actualizaciones futuras del kit. Puedes descargar los genogramas, guías y protocolos para consultarlos a tu propio ritmo.'
}, {
  question: '¿El material es útil para sesiones online?',
  answer: '¡Totalmente! El sistema incluye herramientas digitales diseñadas específicamente para la virtualidad, como plantillas de genogramas editables en Canva y protocolos de visualización sistémica que funcionan perfectamente a través de una pantalla. Dejá de improvisar y dale un marco profesional a tu consulta a distancia.'
}, {
  question: '¿Qué diferencia este kit de otros cursos de Constelaciones?',
  answer: 'La mayoría de las formaciones se centran solo en la teoría de Bert Hellinger. Nosotros nos enfocamos en la metodología práctica y operativa. Aprendés a realizar diagnósticos precisos, a identificar implicancias sistémicas rápidamente y, sobre todo, a aplicar protocolos de protección para no cargar con destinos ajenos.'
}, {
  question: '¿Es seguro el pago y qué pasa si no es lo que esperaba?',
  answer: 'Tu pago está protegido por tecnología de encriptación de grado bancario. Además, confiamos tanto en la calidad de este arsenal sistémico que contás con nuestra garantía de satisfacción. Si sentís que el material no eleva tu práctica profesional o personal, estamos aquí para respaldarte.'
}, {
  question: '¿Puedo aplicarlo en sesiones individuales o solo grupales?',
  answer: 'El sistema está adaptado para ambas modalidades. Incluye guiones específicos para movimientos de solución en consulta individual y dinámicas para el trabajo con representantes en talleres grupales. Es una herramienta versátil que se ajusta a tu forma de trabajar.'
}];
export function FAQ() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  return <section className="bg-[#fdfbf7] py-16 md:py-24" data-id="element-159" data-mp="2o19q9plk3kh">
      <div className="mx-auto max-w-3xl px-4" data-id="element-160" data-mp="7oysooifl1n1">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.35,
        ease: [0.23, 1, 0.32, 1]
      }} className="mb-10 text-center" data-id="element-161" data-mp="7n44907yare7">
          <p className="mb-3 text-xs font-black uppercase tracking-[0.26em] text-[#a8894f]" data-id="element-162" data-mp="mcjqc2wje8nk">
            Despejá tus dudas
          </p>
          <h2 className="font-['Playfair_Display',_serif] text-4xl font-bold text-[#2e1065] md:text-6xl" data-id="element-163" data-mp="vet0usrt220y">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-164" data-mp="2s8w5f74uidue">
          {faqs.map((faq, index) => <div key={index} className="overflow-hidden rounded-2xl border border-[#e8decf] bg-white transition-[border-color,box-shadow] duration-200 ease-out hover:border-[#cfc0e4] hover:shadow-[0_16px_28px_-24px_rgba(46,16,101,0.75)]" data-id="element-165" data-mp="2x6xqtypqup91" data-mpi={index}>
              <button onClick={() => setActiveIndex(activeIndex === index ? null : index)} className="flex w-full items-center justify-between p-5 text-left transition-colors duration-200 ease-out hover:bg-[#fbf8f2] md:p-6" data-id="element-166" data-mp="2bufd7bbfnf1z">
                <span className="pr-8 font-bold leading-tight text-[#2e1065]" data-id="element-167" data-mp="1e7gaojy27cw6">
                  {faq.question}
                </span>
                <div className="shrink-0 text-[#6b4fa0]" data-id="element-168" data-mp="1sxe4bfercusr">
                  {activeIndex === index ? <Minus size={20} data-id="element-169" data-mp="1o2i3pqvggz41" /> : <Plus size={20} data-id="element-170" data-mp="10dpcg7ps3ffr" />}
                </div>
              </button>

              <AnimatePresence data-id="element-171" data-mp="vf4cm9efuxru">
                {activeIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-172" data-mp="372zcfqzr3nqe">
                    <div className="bg-[#fbf8f2] p-5 pt-0 leading-relaxed text-[#665873] md:p-6 md:pt-0" data-id="element-173" data-mp="3uqqznpmtxl6g">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <div className="mt-14 border-t border-[#e6ddcd] pt-10 text-center" data-id="element-174" data-mp="25clxsk1k7pcf">
          <div className="mb-5 inline-flex items-center gap-2 text-[#a8894f]" data-id="element-175" data-mp="29ga3syajmcvk">
            <HelpCircle size={20} data-id="element-176" data-mp="fx1iksy66pdx" />
            <span className="text-sm font-medium uppercase tracking-widest" data-id="element-177" data-mp="fw040ehy3krg">
              Honrar el origen
            </span>
          </div>
          <p className="mx-auto max-w-lg font-['Playfair_Display',_serif] text-lg italic text-[#51405f] md:text-xl" data-id="element-178" data-mp="66p0r8hqpabh">
            "Cuando cada uno ocupa su lugar en el sistema, el amor fluye y la
            vida se vuelve posible. Honrar a los que vinieron antes es la llave
            de tu propia fuerza."
          </p>
          <div className="mt-8" data-id="element-179" data-mp="3ocbne8tg28pe">
            <PurchaseCTA label="Quiero mi sistema completo" data-id="element-180" data-mp="3oba45h29yfwl" />
          </div>
        </div>
      </div>
    </section>;
}